import { render, staticRenderFns } from "./SectionWhy.vue?vue&type=template&id=75dc2530&scoped=true&"
import script from "./SectionWhy.vue?vue&type=script&lang=js&"
export * from "./SectionWhy.vue?vue&type=script&lang=js&"
import style0 from "./SectionWhy.vue?vue&type=style&index=0&id=75dc2530&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dc2530",
  null
  
)

export default component.exports